<template>
  <div class="voucher">
    <navbar title="voucher" />
    <bannerBox />
    <mainContent />
    <footerCarousel />
    <footerBox />
  </div>
</template>

<script>
// @ is an alias to /src
import navbar from '@/components/navbar.vue'
import footerCarousel from '@/components/footerCarousel.vue'
import footerBox from '@/components/footer.vue'
import bannerBox from './component/banner'
import mainContent from './component/mainContent'

export default {
  name: 'Voucher',
  components: {
    navbar,
    footerCarousel,
    footerBox,
    bannerBox,
    mainContent
  }
}
</script>
<style scoped>
.home {
  background: #ffffff;
}
::v-deep .footerBox {
  background-color: #e05283;
}
</style>
